import { render } from "./BasePaginator.vue?vue&type=template&id=07c3802e"
import script from "./BasePaginator.vue?vue&type=script&lang=js"
export * from "./BasePaginator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__